// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import { forwardRef, Ref } from "react";
import { IconProps, Svg } from "@/frameworks/designStuff/components/Contents/Icon";
const SvgPhoneOnUnique24 = forwardRef(
	({ size, title, desc, titleid, descid, ...props }: IconProps, ref: Ref<SVGSVGElement>) => {
		let ariaLabelledBy = titleid ? titleid : "";
		ariaLabelledBy += desc && descid ? ` ${descid}` : "";
		ariaLabelledBy = ariaLabelledBy ? ariaLabelledBy : undefined;
		props["aria-labelledby"] = ariaLabelledBy;
		return (
			<Svg
				xmlns="http://www.w3.org/2000/svg"
				width={size}
				height={size}
				viewBox="0 0 45 45"
				fill="none"
				title={title}
				titleid={titleid}
				desc={desc}
				descid={descid}
				aria-labelledby={ariaLabelledBy}
				aria-hidden={!ariaLabelledBy}
				ref={ref}
				{...props}
			>
				{!!title && <title id={titleId}>{title}</title>}
				{!!desc && <desc id={descId}>{desc}</desc>}
				<path
					fillRule="evenodd"
					clipRule="evenodd"
					d="M15.9035 37.5585L29.7035 37.5586C31.0289 37.5586 32.1035 36.484 32.1035 35.1586V9.35859C32.1035 8.03311 31.0289 6.95859 29.7035 6.95859H15.9035C14.578 6.95859 13.5035 8.03311 13.5035 9.35859V35.1585C13.5035 36.484 14.578 37.5585 15.9035 37.5585ZM29.7035 39.9586C32.3544 39.9586 34.5035 37.8095 34.5035 35.1586V9.35859C34.5035 6.70762 32.3544 4.55859 29.7035 4.55859H15.9035C13.2525 4.55859 11.1035 6.70762 11.1035 9.35859V35.1585C11.1035 37.8095 13.2525 39.9585 15.9035 39.9585L29.7035 39.9586Z"
					fill="#2E2F32"
				/>
				<path
					d="M30.3037 30.9588V9.95879C30.3037 9.29605 29.7665 8.75879 29.1037 8.75879H16.5037C15.841 8.75879 15.3037 9.29605 15.3037 9.95879L15.3037 30.9588C15.3037 31.6215 15.841 32.1588 16.5037 32.1588H29.1037C29.7665 32.1588 30.3037 31.6215 30.3037 30.9588Z"
					fill="#2E2F32"
					fillOpacity={0.12}
				/>
				<path
					fillRule="evenodd"
					clipRule="evenodd"
					d="M25.5039 35.159C25.5039 35.8217 24.9666 36.359 24.3039 36.359H20.7039C20.0411 36.359 19.5039 35.8217 19.5039 35.159C19.5039 34.4963 20.0411 33.959 20.7039 33.959H24.3039C24.9666 33.959 25.5039 34.4963 25.5039 35.159Z"
					fill="#2E2F32"
				/>
			</Svg>
		);
	}
);
SvgPhoneOnUnique24.defaultProps = {
	size: 24,
	focusable: false,
	"aria-hidden": true,
	role: "img",
	fill: "currentcolor"
};
export default SvgPhoneOnUnique24;
